const getters = {
  permission_routers: state => state.permission.routers,
  sidebarRouters: state => state.user.sidebarRouters,
  showRobot: state => state.user.showRobot,
  showPrefill: state => state.user.showPrefill,
  userInfo: state => state.user.userInfo,
  menuIds: state => state.user.menuIds,
  user: state => state.user.user,
  listItem:state => state.device.listItem,
  roles: state => state.user.roles,
  sidebar: state => state.settings.sidebar,
}
export default getters
